<template>
  <div>
    <d-modal
      class="visits__popup"
      v-if="showModal"
      style="background-color: rgba(0,0,0,0.6)!important;">
      <d-modal-header>
        <d-modal-title class="visits__popup_header">
          Rezerwacja numer <span>#{{visit.id}}</span>
          <p v-if="visit.patient_not_present === 1" class="text-danger; font-weight-light;">{{visit.patient_present_message}}</p>
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="visits__popup_content" v-if="visit">
          <div class="visits__popup_content_box">
            Data: <span v-if="getDay">{{getDay.slice(8) + ', '}}</span><span>{{visit.date_start.slice(8, 10) + ' '}}</span><span>{{visit.date_start.slice(5, 7) === '01' ? 'Styczeń' : (visit.date_start.slice(5, 7) === '02' ? 'Luty' : (visit.date_start.slice(5, 7) === '03' ? 'Marzec' : (visit.date_start.slice(5, 7) === '04' ? 'Kwiecień' : (visit.date_start.slice(5, 7) === '05' ? 'Maj' : (visit.date_start.slice(5, 7) === '06' ? 'Czerwiec' :
            (visit.date_start.slice(5, 7) === '07' ? 'Lipiec' : (visit.date_start.slice(5, 7) === '08' ? 'Sierpień' : (visit.date_start.slice(5, 7) === '09' ? 'Wrzesień' : (visit.date_start.slice(5, 7) === '10' ? 'Październik' : (visit.date_start.slice(5, 7) === '11' ? 'Listopad' : 'Grudzień')))))))))) + ' '}}</span>
            <span> {{visit.date_start.slice(0, 4)}}</span>
            <d-button
              v-if="!hiddenInForm && buttonEdit && (myAccount ? myAccount.role !== 'R_USER' : '')"
              class="patient_button"
              :theme="'light'"
              @click.prevent="showModalChangeDate"
              title="Zmiana terminu">
              <template v-if="!spinnerDate"><i class="material-icons">cached</i><span class="ml-2">Zmień termin</span></template>
              <template v-else>
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </template>
            </d-button>
            <d-button
              v-if="!hiddenInForm && buttonEdit && (myAccount ? (myAccount.role === 'R_USER' && myAccount.id === visit.userData.id) : '')"
              class="patient_button"
              :theme="'light'"
              @click.prevent="showModalChangeDate"
              title="Zmiana terminu">
              <template v-if="!spinnerDate"><i class="material-icons">cached</i><span class="ml-2">Zmień termin</span></template>
              <template v-else>
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </template>
            </d-button>
          </div>
          <div class="visits__popup_content_box" v-if="visit.duration">
            Godzina: <span>{{visit.date_start.slice(11, 16)}} - {{visit.date_end.slice(11, 16)}}</span> <span class="shadow-text"><i class="material-icons">watch_later</i> {{visit.duration}} min</span>
          </div>
          <div class="visits__popup_content_box" v-else>
            Godzina: <span>{{visit.date_start.slice(11, 16)}} - {{visit.date_end.slice(11, 16)}}</span> <span class="shadow-text"><i class="material-icons">watch_later</i> {{ visit.service.duration }} min</span>
          </div>
          <div class="visits__popup_content_box">
            Usługa: <span>{{visit.serviceData.name}}</span>
          </div>
          <div class="visits__popup_content_box">
            Specjalista: <span>{{visit.userData.name}} {{visit.userData.last_name}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="visit.service_type !== 'T_OUTSIDE' && visit.service_type !== 'T_WITHOUT_PATIENT'">
            Imię i nazwisko: <span>{{visit.patientData.name}} {{visit.patientData.last_name}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="visit.service_type !== 'T_OUTSIDE' && visit.service_type !== 'T_WITHOUT_PATIENT'">
            PESEL: <span>{{visit.patientData.pesel ? visit.patientData.pesel : 'Brak'}}</span>
          <d-button
            v-if="!hiddenInForm"
            class="patient_button"
            :theme="'danger'"
            @click.prevent="showPatientPopup(visit.patientData.id)"
            title="Podgląd">
            <i class="material-icons">person_search</i>
            <span class="ml-2">Karta pacjenta</span>
          </d-button>
          </div>
          <div class="visits__popup_content_box" v-if="visit.service_type !== 'T_OUTSIDE' && visit.service_type !== 'T_WITHOUT_PATIENT'">
            Telefon: <span>{{visit.patientData.phone ? visit.patientData.phone : 'Brak'}}</span>
          </div>
          <div class="visits__popup_content_box" v-if="visit.service_type !== 'T_OUTSIDE' && visit.service_type !== 'T_WITHOUT_PATIENT'">
            E-mail: <span>{{visit.patientData.email ? visit.patientData.email : 'Brak'}}</span>
          </div>
          <div class="visits__popup_content_box">
            Liczba badań: <span>{{ visit.medical_examinations.length }}</span>
            <div v-for="(exam, index) in visit.medical_examinations" :key="index">
              {{ exam.name + ' - ' + new Date(exam.created_at).toLocaleString('pl-PL') }}
            </div>
          </div>
          <div class="visits__popup_content_box">
            Ankieta COVID:
            <span style="color: #17c671" v-if="visit.survey.length !== 0">Wypełniona</span>
            <span style="color: #c4183c" v-if="visit.survey.length === 0">Niewypełniona</span>
            <d-button
              theme="dark"
              outline
              class="mr-2 ml-4"
              style="border-radius: 20px; min-width: 9rem;"
              :disabled="downloading !== false"
              @click.prevent="download(visit.id)">
              <template v-if="downloading === false">
                <i class="material-icons">cloud_download</i><span class="ml-2">Pobierz</span>
              </template>
              <template v-else>
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </template>
            </d-button>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            v-if="buttonEdit && (myAccount ? myAccount.role !== 'R_USER' : '')"
            theme="primary"
            class="text-nowrap"
            @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
          >
            Edytuj
          </d-button>
          <d-button
            v-if="buttonEdit && (myAccount ? (myAccount.role === 'R_USER' && myAccount.id === visit.userData.id) : '')"
            theme="primary"
            class="text-nowrap"
            @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
          >
            Edytuj
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModal">
            Zamknij
          </d-button>
          <d-button
            v-if="buttonEdit && (myAccount ? myAccount.role !== 'R_USER' : '')"
            outline
            theme="danger"
            class="text-nowrap ml-3"
            @click.prevent="cancelVisit(visit.id)"
          >
            Anuluj rezerwacje
          </d-button>
          <d-button
            v-if="buttonEdit && (myAccount ? (myAccount.role === 'R_USER' && myAccount.id === visit.userData.id) : '')"
            outline
            theme="danger"
            class="text-nowrap ml-3"
            @click.prevent="cancelVisit(visit.id)"
          >
            Anuluj rezerwacje
          </d-button>
        </div>
      </d-modal-body>
    </d-modal>

    <visits-form-patient-popup
      v-if="patientId"
      :on-close-popup="closePatientPopup"
      :is-visible="isPatientPopupVisible"
      :patient-id="patientId"
      :visit-id="visit.id || 0"
      :visit-form="true"/>

    <d-modal
      class="visits__popup time__popup"
      v-if="modalChangeDate"
      @close="closeModalChangeDate"
      style="background-color: rgba(0,0,0,0.6)!important;">
      <d-modal-header>
        <d-modal-title class="visits__popup_header">
          Zmiana terminu
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="visits__popup_body_time">
          <visits-date-of-the-visit
            :key="'keyVisitsDate-' + keyVisitsDate"
            :items-where="''"
            :service-id="visit.service_id"
            :user-id="visit.userData.id ? visit.userData.id : visit.user_id"
            :institution-id="visit.institutionData.id ? visit.institutionData.id : visit.institution_id"
            :patient-id="visit.patientData.id ? visit.patientData.id : visit.patient_id"
            :medical-id="this.$route.params.id ? this.$route.params.id : ''"
            :data-value="visit"
            :popup-date="true"
            :popup-date-start="false"
            :patient-popup="true"
            :single-shift="true"
            :reload="reloadData"
            :popup-close="closeModal"
            :popup-close-date="closeModalChangeDate"/>
        </div>
      </d-modal-body>
    </d-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';
import VisitsFormPatientPopup from '@/components/forms/Visits/VisitsFormPatientPopup.vue';
import VisitsDateOfTheVisit from '@/components/forms/Visits/VisitsDateOfTheVisit.vue';

export default {
  name: 'visits-popup',
  components: { VisitsFormPatientPopup, VisitsDateOfTheVisit },
  props: {
    buttonEdit: {
      default: true,
      type: Boolean
    },
    closeModal: {
      required: true,
      type: Function
    },
    getDay: {
      type: String
    },
    hiddenInForm: {
      default: false,
      type: Boolean
    },
    myAccount: {
      required: true,
      type: [Array, Object, String]
    },
    reloadData: {
      type: Function
    },
    showModal: {
      required: true,
      type: Boolean
    },
    visit: {
      required: true,
      type: [Array, Object]
    }
  },
  watch: {
    'modalChangeDate': function () {
      this.keyVisitsDate += 1;
    }
  },
  data () {
    return {
      componentKeyPatient: 0,
      downloading: false,
      isPatientPopupVisible: false,
      keyVisitsDate: 0,
      modalChangeDate: false,
      patientId: '',
      spinnerDate: false
    }
  },
  methods: {
    download (visitID) {
      this.downloading = true;
      this.$http.post('/visits/get-survey-pdf/' + visitID, {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'rezerwacja-nr-';
        link.setAttribute('download', filename + visitID + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloading = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.downloading = false;
      });
    },
    showPatientPopup(id) {
      Vue.set(this, 'patientId', id);
      if (this.visit.patientData.id === this.patientId) {
        Vue.nextTick(() => {
          this.isPatientPopupVisible = true;
        })
      }
    },
    closePatientPopup() {
      this.isPatientPopupVisible = false;
      this.patientId = '';
    },
    showModalChangeDate() {
      this.spinnerDate = true;
      setTimeout(() => {
        this.modalChangeDate = true;
        this.spinnerDate = false;
      }, 1000);
    },
    closeModalChangeDate() {
      this.modalChangeDate = false;
    },
    cancelVisit (visitID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/visits/cancel/',
        id: visitID,
        successTitle: 'Anulowano wizytę',
        successText: 'Wybrana wizyta została anulowana',
        confirmTitle: 'Czy na pewno chcesz anulować tą wizytę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Anulowanie wizyty nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
}
</script>

<style lang="scss">
  @import '../../assets/scss/visit-popup.scss';
</style>
